export const ARCHIMATE_RELATION_PREFIX = 'ui-archimate-relation-relations-';

export function getArchimateIcon(suffix: string): string {
  return `${ARCHIMATE_RELATION_PREFIX}${suffix}`;
}

export function getRelationRoleArrows(relationRoleName: string): string {
  return relationRoleArrows[relationRoleName];
}

export const relationRoleArrows: {
  [key in string]: string;
} = {
  accesses: getArchimateIcon('access-right'),
  aggregates: 'ui-line',
  assignedTo: 'ui-arrow-right-solid',
  associatedTo: getArchimateIcon('association-right'),
  sendsOutputTo: getArchimateIcon('flow-right'),
  influences: getArchimateIcon('influence-right'),
  isComposedOf: 'ui-line',
  realises: getArchimateIcon('realization-right'),
  specializes: getArchimateIcon('specialization-right'),
  serves: 'ui-dependency-right',
  triggers: 'ui-arrow-right-solid',
  basicLine: 'ui-arrow-right-solid',
  enables: 'ui-dependency-right',
  isParentOf: 'ui-line',
};

export function getRelationRoleLines(relationType: string): string {
  return relationRoleLines[relationType];
}

export const relationRoleLines: { [key in string]: string } = {
  AccessRelation: getArchimateIcon('access-right'),
  AggregationRelation: 'ui-hierarchy-left',
  AssignmentRelation: getArchimateIcon('assignment-right'),
  AssociationRelation: getArchimateIcon('association-right'),
  InfluenceRelation: getArchimateIcon('influence-right'),
  CompositionRelation: getArchimateIcon('composition-right'),
  RealisationRelation: getArchimateIcon('realization-right'),
  FlowRelation: getArchimateIcon('flow-right'),
  ServingRelation: getArchimateIcon('serving-right'),
  SpecializationRelation: getArchimateIcon('specialization-right'),
  TriggeringRelation: getArchimateIcon('triggering-right'),
  Line: 'ui-line',
  HierarchyRelation: 'ui-hierarchy-left',
  DependencyRelation: 'ui-line',
};
